import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { getFamilyFestFaqCategoriesAsync, getFamilyFestFaqCategoriesByTypeAsync, getFamilyFestFaqCategoryByIdAsync, createFamilyFestFaqCategoryAsync, updateFamilyFestFaqCategoryAsync, deleteFamilyFestFaqCategoryAsync } from './familyFestFaqCategoryThunk';
const initialState = {
    status: APIStatus.IDLE,
    categories: [],
    selectedCategory: null
};
export const familyFestFaqCategorySlice = createSlice({
    name: 'familyFestFaqCategory',
    initialState,
    reducers: {
        clearSelectedCategory: (state) => {
            state.selectedCategory = null;
        }
    },
    extraReducers: (builder) => {
        builder
            // Get All
            .addCase(getFamilyFestFaqCategoriesAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getFamilyFestFaqCategoriesAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.categories = action.payload;
        })
            .addCase(getFamilyFestFaqCategoriesAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            // Get By Type (the FAQs tab's Registration | Event page list)
            .addCase(getFamilyFestFaqCategoriesByTypeAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getFamilyFestFaqCategoriesByTypeAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.categories = action.payload;
        })
            .addCase(getFamilyFestFaqCategoriesByTypeAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            // Get By Id
            .addCase(getFamilyFestFaqCategoryByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getFamilyFestFaqCategoryByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.selectedCategory = action.payload;
        })
            .addCase(getFamilyFestFaqCategoryByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            // Create
            .addCase(createFamilyFestFaqCategoryAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createFamilyFestFaqCategoryAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            if (action.payload.data) {
                state.categories.push(action.payload.data);
            }
        })
            .addCase(createFamilyFestFaqCategoryAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            // Update
            .addCase(updateFamilyFestFaqCategoryAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateFamilyFestFaqCategoryAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            if (action.payload.data) {
                if (state.selectedCategory?.id === action.payload.data.id) {
                    state.selectedCategory = action.payload.data;
                }
            }
        })
            .addCase(updateFamilyFestFaqCategoryAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            // Delete
            .addCase(deleteFamilyFestFaqCategoryAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteFamilyFestFaqCategoryAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            if (action.payload.data) {
                state.categories = state.categories.filter((c) => c.id !== action.payload.data?.id);
                if (state.selectedCategory?.id === action.payload.data?.id) {
                    state.selectedCategory = null;
                }
            }
        })
            .addCase(deleteFamilyFestFaqCategoryAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export const { clearSelectedCategory } = familyFestFaqCategorySlice.actions;
export default familyFestFaqCategorySlice.reducer;
